import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Button,
  Box,
  TextField,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useSessionStorage } from "../../hooks/useSessionStorage";
import SendIcon from '@mui/icons-material/Send';
import AccessContainer from "../common/AccessContainer";
import { useParams } from "react-router-dom";
import RcsSuggestions from "./RcsSuggestions";

const ConversationPage = () => {

  const {conversationId} = useParams(); 
  const [newReply, setNewReply] = useState("");
  const [conversation, setConversation] = useState(null);
  const [user] = useSessionStorage("user", null);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const scrollRef = useRef(null); // Reference for the scroll container

  const fetchConversation = async () => {
      if (!conversationId) return;
    const res = await fetch("/api/MessageHub/GetMessageHubMessages", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ conversationId }),
    });
    const data = await res.json();
    if (data.length > 0) {
      setConversation(data[0]);
    }
  };

  useEffect(() => {
    markAsRead();
  }, [])

  useEffect(() => {
    if (!user || !conversationId) return;
    fetchConversation();

    const intervalId = setInterval(() => {
      fetchConversation();
    }, 10000);

    return () => clearInterval(intervalId);
  }, [conversationId, user]);

  const markAsRead = async () => {
    await fetch("/api/MessageHub/UpdateMessageHubMessage", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ conversationId }),
    });
  };



  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [conversation]);

  const displayRecipient = conversation ? `${conversation?.recipientName ? conversation.recipientName + ' ' : ''}+${conversation.to}` : '';

  

  return (
        <AccessContainer
          customStyle={{ maxWidth: "100%", width: "100%" }}
          allowedRoles={["NexusAdmin", "MessageHub"]}
        >
          <Container sx={{ padding: "2rem 0", maxHeight: "100vh", display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h6" gutterBottom>
            {conversation && displayRecipient} (read only)
            </Typography>
            <Box
              ref={scrollRef}
              sx={{
                flex: 1,
                overflowY: "auto",
                display: "flex",
                flexDirection: "column-reverse",
                padding: "1rem 0",
                backgroundColor: "#fff",
                borderRadius: "8px",
                maxHeight: "40vh",
              }}
            >
              {conversation?.replies?.length ? (
                <Box component="ul" sx={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {conversation.replies.map((reply, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: reply.from === conversation.from ? "flex-end" : "flex-start",
                        marginBottom: 2,
                      }}
                    >
                      <Box
                        sx={{
                          maxWidth: "75%",
                          padding: 1,
                          borderRadius: reply.from === conversation.from ? "18px 18px 0 18px" : "18px 18px 18px 0",
                          backgroundColor: reply.from === conversation.from ? "#1976D2" : "#f0f0f0",
                          color: reply.from === conversation.from ? "#fff" : "#000",
                          wordBreak: "break-word",
                        }}
                      >
                        <Typography variant="subtitle2" fontWeight="bold">
                           {reply.user}
                        </Typography>
                        <Typography variant="body1">{reply.message}</Typography>
                        <RcsSuggestions suggestions={reply.rcsSuggestions}/>
                        <Typography variant="caption" display="block" sx={{ marginTop: "4px" }}>
                          {new Date(reply.time).toLocaleString()}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography variant="body1">No replies</Typography>
              )}
            </Box>


          </Container>
        </AccessContainer>
  );
};

export default ConversationPage;